import type { Pagination } from '@/common/pagination/types.ts';
import {
  getSalesOrderControllerGetSalesOrdersQueryKey,
  getSalesOrderControllerGetSalesOrdersQueryOptions,
} from '@/generated/api/sales-order.ts';
import { filterValuesToDtoShape, type SortSelectionString } from '@pac/filter';
import {
  type NullableSalesOrderFilter,
  SALES_ORDER_FILTER_DEFINITION,
  SALES_ORDER_FILTER_METADATA,
  type SALES_ORDER_SORT_COLUMNS,
} from '@pac/filter/shared/sales-orders';

export function getSalesOrdersQueryOptions(
  filter: NullableSalesOrderFilter,
  pagination: Pagination,
  sorting: SortSelectionString<typeof SALES_ORDER_SORT_COLUMNS> | null,
) {
  return getSalesOrderControllerGetSalesOrdersQueryOptions({
    ...filterValuesToDtoShape(
      SALES_ORDER_FILTER_DEFINITION,
      filter,
      SALES_ORDER_FILTER_METADATA,
    ),
    ...pagination,
    sort: sorting ?? undefined,
  });
}

export function getSalesOrdersQueryKey(
  filter: NullableSalesOrderFilter,
  pagination: Pagination,
  sorting: SortSelectionString<typeof SALES_ORDER_SORT_COLUMNS> | null,
) {
  return getSalesOrderControllerGetSalesOrdersQueryKey({
    ...filterValuesToDtoShape(
      SALES_ORDER_FILTER_DEFINITION,
      filter,
      SALES_ORDER_FILTER_METADATA,
    ),
    ...pagination,
    sort: sorting ?? undefined,
  });
}
